import protobuf from "refractor/protobuf";
export default protobuf;